export default "__VITE_ASSET__d15a07b8__"